import type { FirebaseOptions } from 'firebase/app';

export const environment = {
  production: true,
  apiBaseUrl: 'https://api.staging.flourish.wine/api',
  userPortalUrl: 'https://staging.flourish.wine',
  firebaseConfig: null as FirebaseOptions | null,
  turnstileSiteKey: '0x4AAAAAACOew0MDA1jnCKNo'
};
